import { 
  Component, OnInit, OnDestroy, ViewChildren, QueryList, 
  ElementRef, AfterViewInit, Input, Output, EventEmitter,
  ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'player-seek-bar',
  templateUrl: './player-seek-bar.component.html',
  styleUrls: ['./player-seek-bar.component.scss']
})
export class PlayerSeekBarComponent implements OnInit, OnDestroy, AfterViewInit {

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
  }

  @Input()
  public seekPosition : number;

  @Input()
  public duration: number;

  @Input()
  public isLive : boolean;

  @Input()
  public seekPreviewValue: number;

  @Output() 
  public seek : EventEmitter<number> = new EventEmitter<number>();

  @Output()
  public seekDrag : Subject<number> = new Subject<number>();

  @ViewChild('seekTrackReceiver', { static: true })
  private seekTrackReceiver : ElementRef = null;

  public dragging = false;

  public seekDragPosition : number;
  private seekStartDragClientX : number;
  private seekStartDragOffsetX : number;
  private documentMouseUp;
  private documentMouseMove;

  public get displaySeekPosition() {
    return Math.max(0, Math.min(1, this.seekPosition));
  }

  private range(value, min, max) {
    if (value < min)
      return min;
    if (value > max)
      return max;

    return value;
  }

	seekMouseUp(ev : MouseEvent) {
		this.dragging = false;
		this.seekPosition = this.seekDragPosition;
    this.seek.emit(this.seekPosition);
	}

	seekMouseDown(ev : MouseEvent) {
		this.dragging = true;
		this.seekStartDragClientX = ev.clientX;
		this.seekStartDragOffsetX = this.seekPosition;

    let seekTrackReceiverEl = <HTMLElement>this.seekTrackReceiver.nativeElement;
    if (ev.target == seekTrackReceiverEl)
      this.seekStartDragOffsetX = ev.offsetX / seekTrackReceiverEl.offsetWidth;

		this.documentMouseUp = (ev) => {
			document.removeEventListener('mouseup', this.documentMouseUp);
			document.removeEventListener('mousemove', this.documentMouseMove);
			this.documentMouseUp = null;
			this.documentMouseMove = null;
			this.seekMouseUp(ev);
		};
		
		this.documentMouseMove = (ev) => {
			this.seekMouseMove(ev);
		};

    this.seekMouseMove(ev);

		document.addEventListener('mouseup', this.documentMouseUp);
		document.addEventListener('mousemove', this.documentMouseMove);

    this.seekPosition = this.seekDragPosition;
    this.seek.emit(this.seekPosition);
	}

	seekMouseMove(ev : MouseEvent) {
		if (!this.dragging)
			return;

    let seekTrackReceiverEl = <HTMLElement>this.seekTrackReceiver.nativeElement;
		let total = seekTrackReceiverEl.offsetWidth;

    let travel = (ev.clientX - this.seekStartDragClientX) / total;
		let x = this.seekStartDragOffsetX + travel;
		let desiredSpot = Math.round(x * 1000) / 1000.0;

		// TODO: seek
    this.seekDragPosition = this.range(desiredSpot, 0, 1); 
    this.seekDrag.next(this.seekDragPosition);
	}

}
